import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ContentChildren,
  input,
  QueryList,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'pr-information-box',
  imports: [CommonModule, MatIconModule],
  templateUrl: './information-box.component.html',
  styleUrl: './information-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationBoxComponent {
  theme = input<'info' | 'warn'>();
  colourClass = computed(() => {
    if (this.theme() === 'warn') {
      return 'bg-red-100 text-red-400';
    }
    return 'bg-blue-100 text-primary-400';
  });
  icon = computed(() => {
    if (this.theme() === 'warn') {
      return 'warning';
    }
    return 'info';
  });

  @ContentChildren(MatButton) buttonQueryList?: QueryList<MatButton>;
}
